import { ID, Task } from '@griply/types';
import { MutableRefObject, useEffect, useRef } from 'react';

// A drag's DataTransfer carries ids only; drop targets resolve them against every mounted list.
const mountedLists = new Set<MutableRefObject<Task[]>>();

export const useRegisterDraggableTasks = (tasks: Task[]) => {
  // read through a ref so a changed list doesn't re-register
  const tasksRef = useRef(tasks);
  tasksRef.current = tasks;

  useEffect(() => {
    mountedLists.add(tasksRef);
    return () => {
      mountedLists.delete(tasksRef);
    };
  }, []);
};

export const findDraggableTasks = (ids: ID[]): Task[] => {
  const wanted = new Set(ids);
  const found = new Map<ID, Task>();

  mountedLists.forEach((listRef) =>
    listRef.current.forEach((task) => {
      if (wanted.has(task.id) && !found.has(task.id)) {
        found.set(task.id, task);
      }
    }),
  );

  return ids.flatMap((id) => found.get(id) ?? []);
};
